// create campaign router view

const manageEditPhraseBookPhraseEdit = 'manage.editPhraseBook.phrase.edit'

const manageEditPhraseBookPhraseEditConfig = {
  params: {
    service: null,
    phrase: null,
  },
  component: 'editPhraseForm',
  resolve: {
    service: function($transition$) {
      'ngInject'
      return $transition$.params().service
    },
    phrase: function($transition$) {
      'ngInject'
      return $transition$.params().phrase
    },
  },
}

export { manageEditPhraseBookPhraseEdit, manageEditPhraseBookPhraseEditConfig }
